// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__qBfu5","panel":"Robot_panel__N+SuG","wrapper":"Robot_wrapper__I-84n","info":"Robot_info__7dUfy","unit":"Robot_unit__idX6b"};